<script>
    import AssetTypeAddHeader from '@/components/page-asset-type-edit/asset-type-add/AssetTypeAddHeader.vue';
    import AssetTypeAddData from '@/components/page-asset-type-edit/asset-type-add/AssetTypeAddData.vue';

    export default {
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_ASSET_TYPE_ADD}
        },
        components: {
            AssetTypeAddHeader: AssetTypeAddHeader,
            AssetTypeAddData: AssetTypeAddData,
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <AssetTypeAddHeader />
        <hr class="hr_light_98">
        <AssetTypeAddData />
    </div>
</template>